import * as actualiteStyles from '../../styles/actualites/sciencespo/actualite.module.scss';

import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import CategoriesContainer from '../shared/CategoriesContainer';
import IconContainer from '../shared/IconContainer';
import PolyLink from '../shared/PolyLink';
import React from 'react';
import { assign } from 'lodash';
import { useTranslation } from 'react-i18next';
import {altNN} from '../../utils/parsing';

const getPreview = (title, preview) => {
  const titleRows = !title ? 0 : title.length / 25;

  const previewSize = 200 - Math.max(0, titleRows * 25);
  if (preview && preview.length > previewSize) {
    let idxSup = previewSize;
    let idxInf = previewSize;
    let truncIdx = previewSize;
    const stopChars = [' ', '.', '!', ','];
    while (idxSup <= preview.length && idxInf >= 0) {
      if (stopChars.includes(preview.charAt(idxSup))) {
        truncIdx = idxSup;
        break;
      } else {
        idxSup++;
      }
      if (stopChars.includes(preview.charAt(idxInf))) {
        truncIdx = idxInf;
        break;
      } else {
        idxInf++;
      }
    }

    return preview.substring(0, truncIdx) + ' ...';
  }
  return preview;
};

const News = ({ categories, title, preview, href, cover, getCategories }) => {
  const { t } = useTranslation();

  const fullCategories = React.useMemo(
    () =>
      categories?.map((category) => assign(category, { variant: 'contained' })),
    [categories]
  );

  return (
    <div className={actualiteStyles.bloc}>
      <div className={actualiteStyles.imgBloc}>
        <GatsbyImage
          alt={altNN('')}
          image={getImage(cover?.imageFile)}
          loading="eager"
          style={{ height: '100%', width: '100%' }}
          title={cover?.name || ''}
        >
        </GatsbyImage>
      </div>
      <div className={actualiteStyles.innerBloc}>
        {categories?.length > 0 && (
          <div className={actualiteStyles.categories}>
            {categories?.length > 0 && (
              <CategoriesContainer
                elements={fullCategories}
                getCategories={getCategories}
                isUnique
              />
            )}
          </div>
        )}
        <PolyLink
          ariaLabel={t('event.guide.page.more.url')}
          className={actualiteStyles.linkRoot}
          name="news-focus"
          url={href}
        >
          {title && (
            <div style={{ marginBottom: 20 }}>
              <h3 className={actualiteStyles.title}>{title}</h3>
            </div>
          )}
          {preview && (
            <div style={{ marginBottom: 20 }}>
              <p className={actualiteStyles.preview}>
                {getPreview(title, preview)}
              </p>
            </div>
          )}
          <div className={actualiteStyles.moreContainer}>
            <p className={actualiteStyles.more}>
              {t('event.guide.page.more.url')}
            </p>
            <div style={{ marginLeft: 8 }}>
              <IconContainer
                classname={actualiteStyles.more}
                color="BLACK"
                icon="ARROW_RIGHT_NORMAL"
                size={20}
              />
            </div>
          </div>
        </PolyLink>
      </div>
    </div>
  );
};

News.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      clicked: PropTypes.bool,
    })
  ),
  cover: PropTypes.shape({
    imageFile: PropTypes.object.isRequired,
    name: PropTypes.string,
  }),
  getCategories: PropTypes.func.isRequired,
  href: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  preview: PropTypes.string,
  title: PropTypes.string,
};

export default News;
